import makeStyles from '@mui/styles/makeStyles';

const adjustPolicyUtilizationConfirmationModalStyle = makeStyles(
  {
    modalTitle: {
      fontWeight: '600',
    },
    sectionTitle: {
      color: '#373f51',
      fontWeight: '500',
      marginTop: '16px',
      marginBottom: '4px',
    },
    claimIdValue: {
      marginBottom: '8px',
    },
    divider: {
      margin: '16px 0px',
    },
    changeBlock: {
      marginBottom: '16px',
    },
    adjustmentLine: {
      fontWeight: '500',
      marginBottom: '8px',
    },
    comparisonGrid: {
      display: 'grid',
      gridTemplateColumns: 'max-content max-content',
      columnGap: '12px',
      rowGap: '4px',
    },
    comparisonLabel: {
      color: 'rgba(0, 0, 0, 0.6)',
    },
    comparisonValue: {
      fontWeight: '500',
    },
    buttonContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    confirmButton: {
      color: 'white',
      backgroundColor: '#007DFF',
      '&:hover': {
        backgroundColor: '#007DFF',
      },
    },
    cancelButton: {
      color: 'white',
      backgroundColor: '#D4424E',
      '&:hover': {
        backgroundColor: '#D4424E',
      },
    },
  },
  { name: 'adjust-policy-utilization-confirmation-modal' }
);

export { adjustPolicyUtilizationConfirmationModalStyle };
